<form [formGroup]="priceForm" class="row" (ngSubmit)="apply()">
    <div class="col-12">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Min Rental Price</mat-label>
            <input matInput type="number" formControlName="min">
            <!-- <mat-hint>Min</mat-hint> -->
        </mat-form-field>
    </div>
    <div class="col-12">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Max Rental Price</mat-label>
            <input matInput type="number" formControlName="max">
            <!-- <mat-hint>Max</mat-hint> -->
        </mat-form-field>
    </div>
    <div class="col-lg-12 text-right">
        <button type="submit" class="rui-btn rui-btn--outline" >Apply</button>
    </div>
</form>